module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('el-button', {
    staticClass: "scn-btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.scanning = true
      }
    }
  }, [_c('maximize-icon'), _vm._v(" "), _c('span', {
    staticClass: "scan"
  }, [_vm._v("Scan QR-Code")])], 1), _vm._v(" "), _c('scan', {
    attrs: {
      "id": "modal",
      "scanning": _vm.scanning
    },
    on: {
      "update:scanning": function($event) {
        _vm.scanning = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79bd7fdc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verify.vue
// module id = 1189
// module chunks = 7